module.exports = __webpack_public_path__ + "static/img/logo-across.f0385d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/logo-across.png
// module id = 432
// module chunks = 103